import {Location} from '@angular/common';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {BlockTemplateComponent} from 'src/app/components/block-template/block-template/block-template.component';
import {environment} from 'src/environments/environment.prod';
import {ContaService} from '../../../api/module/erp/services/auth/conta.service';
import {jwtAuthService} from '../../../api/module/erp/services/auth/jwtAuthService';
import {CaptchaComponent} from '../../area-logada/shared/components/captcha/captcha.component';
import {ErrorResponse} from './../../../api/model/common/error-response.model';
import {LoginViewModel} from './../../../api/model/conta/login-view-model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  blockTemplate: BlockTemplateComponent | undefined;

  public login = new LoginViewModel();
  userId!: any;
  token!: any;
  isEmailConfirmado: boolean = false;
  ambiente: boolean = environment.production;
  isLoggedIn = false;
  isLoginFailed = false;
  disabledBtnLogin = false;
  errorMessage = '';
  showPassword: boolean = false;
  captchaToken: string | null = null;
  @ViewChild('captcha') captcha: CaptchaComponent;

  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private jwtAuthService: jwtAuthService,
    private contaService: ContaService,
    private toastr: ToastrService,
    private router: Router,
    private _spinnerService: SpinnerService,
    private _errorLogging: ErrorLoggingService,
  ) {}
  ngAfterViewInit(): void {
    this.iniciarSpinner();

    if (this.jwtAuthService.isUsuarioLogado()) {
      const urlFirstAccess = this.jwtAuthService.sessaoService().urlFirstAccess;
      if (urlFirstAccess) {
        location.replace(urlFirstAccess);
      } else {
        this.router.navigate(['dashboard']);
      }
    } else {
      this.router.navigate(['/login']);
    }

    this.pararSpinner();
  }

  ngOnInit() {
    this.getParametrosUrl();
  }

  getDadosusuarioLogado() {}

  showHidePassword() {
    this.showPassword = !this.showPassword;
  }

  onRedirectCadastro() {
    this.iniciarSpinner();
    this.router.navigate(['/cadastro']);
    this.pararSpinner(1000);
  }
  onRedirectEsqueceuSenha() {
    this.router.navigate(['/esqueceu-senha']);
  }
  onRedirectEsqueceuEmail() {
    this.router.navigate(['/esqueceu-email']);
  }

  onLogin() {
    if (!this.captchaToken) {
      this.toastr.error('Por favor, complete o CAPTCHA antes de enviar.', 'Aviso');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    } else {
      this.iniciarSpinner();
      try {
        if (this.login.email && this.login.password) {
          this.contaService
            .onLogin(this.login, this.captchaToken)
            .pipe(finalize(() => this.pararSpinner()))
            .subscribe(
              data => {
                this.captcha.reset();
                this.captchaToken = null;
                // Verifica se há uma URL de redirecionamento salva
                const redirectUrl = localStorage.getItem('redirectAfterLoginColab');
                if (redirectUrl) {
                  localStorage.removeItem('redirectAfterLoginColab');
                  this.router.navigateByUrl(redirectUrl);
                  return;
                }

                // 2. Se não tiver URL de redirecionamento, verifica primeiro acesso
                if (this.jwtAuthService.sessaoService().urlFirstAccess) {
                  const firstAccessUrl = this.jwtAuthService.sessaoService().urlFirstAccess;
                  this.jwtAuthService.sessaoService().urlFirstAccess = '';
                  location.replace(firstAccessUrl);
                  return;
                }

                // 3. Redirecionamento padrão
                this.toastr.success('Login efetuado com sucesso!');
                this.router.navigate(['dashboard']);
                location.reload();
              },

              (erro: ErrorResponse) => {
                this.processaErro(erro);
                this.captcha.reset();
                this.captchaToken = null;

                const erroVM = {
                  login: this.login,
                };

                this.erroSentry('Erro ao tentar realizar o login!', erro, 'Erro ao tentar realizar o login', erroVM);
              },
            );
        } else {
          this.pararSpinner();
        }
      } catch (error) {
        this.pararSpinner();
      }
    }
  }
  erroSentry(tituloErro: any, erro: any, mensagemErro: any, data: any) {
    this._errorLogging.logError(mensagemErro, data, {
      contexto: tituloErro,
      data: data,
    });
  }

  private processaErro(erro: ErrorResponse) {
    this.isLoginFailed = true;
    this.isLoggedIn = false;

    this.toastr.error(erro.message);
    this.toastr.toastrConfig.preventDuplicates = true;

    this.pararSpinner();
  }

  onConfirmEmail(token: string, id: string) {
    try {
      this.iniciarSpinner();
      if (this.token && this.userId) {
        this.contaService
          .onConfirmEmail(token, id)
          .pipe(
            finalize(() => {
              this.pararSpinner();
            }),
          )
          .subscribe(
            data => {
              this.isEmailConfirmado = true;
              this.router.navigate(['/login']);
            },
            (erro: ErrorResponse) => {
              this.isEmailConfirmado = false;
              this.processaErro(erro);
            },
          );
      }
    } catch (error) {
      this.pararSpinner();
      console.error(error);
    }
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
  getParametrosUrl(): string[] {
    this.iniciarSpinner();
    let itemReturn: any = [];
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      this.userId = params['userid'];
      this.pararSpinner();
      if (this.token != null && this.userId != null) {
        this.onConfirmEmail(this.token, this.userId);
      }
      itemReturn = {
        token: this.token,
        userId: this.userId,
      };
    });

    this.pararSpinner();
    return itemReturn;
  }
}
